import { BaseBodyResponse } from "@/api/api";

export const TypeSavings = {
  REGULAR_TERM_DEPOSIT: "REGULAR_TERM_DEPOSIT", // kỳ hạn thường
  FLEXIBLE_TERM_DEPOSIT: "FLEXIBLE_TERM_DEPOSIT", // rút gốc linh hoạt
  RECURRING_DEPOSIT: "RECURRING_DEPOSIT", // tích lũy
};
export interface SavingsProduct {
  content: string;
  desc: string;
  image: string;
  title: string;
  type: string;
}
export interface SavingListResponse extends BaseBodyResponse {
  products: SavingsProduct[];
}
export interface CreateSavingReq {
  sourceAccount: string;
  savingAmount: number;
  savingsType: string;
  savingsDuration: number;
  durationUnit: string;
  savingsClassType: string;
  interestPaymentCycle?: string;
  rollOverType: string;
  currency: string;
  periodicDeposit?: {
    method: string;
    frequency: string;
    amount: string;
  };
}

export interface SavingDetail {
  durationType: string;
  expectedMaturityInterest: number;
  makerDate: string;
  makerName: string;
  rollOverType: string;
  savingAmount: number;
  savingInterest: number;
  savingsType: string;
}
export interface CreateSavingResponse extends BaseBodyResponse {
  savingsId: string;
  detail: SavingDetail;
  detailParams: { key: string; value: string }[];
  resultCode: string;
  resultDesc: string;
}

export interface CalSavingsIRateReq {
  amount: string;
  type: string;
  savingsMethod: string;
  durationValue: number;
  durationUnit: string;
  savingsFrequency?: string;
}

export interface SavingInterestTypeReq {
  type: string;
  method: string;
  frequency?: string;
  amount: string;
}

export interface SavingInterestTypeResponse extends BaseBodyResponse {
  durations: {
    displayDuration: string;
    durationUnit: string;
    durationValue: number;
  }[];
}

export interface CalSavingResponse extends BaseBodyResponse {
  calculatedInterestRate: number;
  interestRate: any;
}

export interface ConfirmCreateSavingReq {
  otpId: string;
  otp: string;
  transactionId: string;
}

export interface Savings {
  accountClass: string;
  accountName: string;
  accountNameAlias: string;
  accountNo: string;
  accountStatus: string;
  accountTypeName: string;
  amountLimit: number;
  authStatus: string;
  availableBalance: number;
  availableBalanceDisplay: string;
  blockedAmount: number;
  checkerDate: string;
  creditStatus: number;
  currency: string;
  currentBalance: number;
  customerName: string;
  customerNo: string;
  dayLimit: number;
  debitStatus: number;
  dueDate: string;
  isFavorite: string;
  makerDate: string;
  minBalance: number;
  numberLimit: number;
  openChannel: string;
  openDate: string;
  openDateDisplay: string;
  overdraftAmount: number;
}

export interface AllSavingsResponse extends BaseBodyResponse {
  ewalletAccounts: Savings[];
}

export interface AllSavingsReq {
  type?: string;
  channel?: string;
  status?: string;
  accountNo?: string;
  pageNo: number;
  pageSize: number;
}

export interface SavingsDetailResponse extends BaseBodyResponse {
  accountInfoFields: { key: string; name: string; value: string }[];
  accountOverview?: {
    interestAmount: number;
    interestAmountDisplay: string;
    numberOfDay: number;
    numberOfDayDisplay: string;
    numberOfDayProcess: number;
    numberOfDayProcessDisplay: string;
    passedDays: number;
    passedDaysDisplay: string;
    principalAmount: number;
    principalAmountDisplay: string;
    savingsAmount: number;
    savingsAmountDisplay: string;
    type: string;
    periodicDepositMethod: string;
  };
  interestRateFields: { key: string; value: string }[];
}

export interface SavingsTransactionHistoryReq {
  accountNo: string;
  fromDate: string;
  toDate: string;
  isIncoming: boolean;
  page?: number;
  fromAmount: string;
  toAmount: string;
  pageSize?: number;
}

export interface SavingsRolloverHistoryReq {
  accountNo: string;
  fromDate: string;
  toDate: string;
  minAmount: string;
  maxAmount: string;
  page?: number;
  pageSize?: number;
}

export interface SavingsTransHistoryResponse extends BaseBodyResponse {
  fundsTransfer: {
    items: {
      displayAmount: string;
      displayDate: string;
      displayTime: string;
      totalAmount: string;
      totalAmountDisplay: string;
      transId: string;
      transType: string;
      accountNo: string;
      fromMessage?: string;
    }[];
    totalPages: number;
    totalRecords: number;
    pageNo: number;
  };
}

export interface SavingsRolloverHistoryResponse extends BaseBodyResponse {
  histories: {
    fromDateDisplay: string;
    interestAmountDisplay: string;
    interestRateDisplay: string;
    principalAmountDisplay: string;
    toDateDisplay: string;
    transId: string;
  }[];
  pageNo: number;
  totalPages: number;
  totalRecords: number;
}

export interface PreviewSavingsResponse extends BaseBodyResponse {
  savingsAccountInfoData: {
    principalAmount: number;
    savingsType: string;
    savingsTypeDisplay: string;
    interestRateDisplay: string;
    savingsAmountDisplay: string;
    openDate: string;
    openDateDisplay: string;
    closedDate: string;
    closedDateDisplay: string;
    rollOverTypeDisplay: string;
    paymentMethodDisplay: string;
    remainPrincipalAmount: number;
    remainPrincipalAmountDisplay: string;
    currency: string;
  };
  savingsAccountInfo: {
    key: string;
    name: string;
    value: string;
  }[];
  transactionInfo: {
    key: string;
    name: string;
    value: string;
  }[];
  beneficiaryAccounts: {
    accountClass: string;
    accountName: string;
    accountNo: string;
    accountStatus: string;
    amountLimit: number;
    authStatus: string;
    availableBalance: number;
    availableBalanceDisplay: string;
    blockedAmount: number;
    checkerDate: string;
    checkerID: string;
    creditStatus: number;
    currency: string;
    currentBalance: number;
    customerName: string;
    customerNo: string;
    dayLimit: number;
    debitStatus: number;
    description: string;
    makerDate: string;
    makerID: string;
    minBalance: number;
    numberLimit: number;
    openDate: string;
    overdraftAmount: number;
  }[];
}

export interface InitActionSavingsAccountReq {
  accountNo: string;
  action: string;
  actionAmount?: string;
  beneficiaryAccountNo: string;
}

export interface ConfirmActionSavingsAccountReq {
  refId: string;
  authType: string;
  otpId: string;
  otp: string;
}

export interface ConfirmActionSavingsAccountResponse extends BaseBodyResponse {
  transactionInfo: { key: string; name: string; value: string }[];
  resultCode: string;
  resultDesc: string;
}
